import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";

export const getAllColumns = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({
    viewModal,
    updateModal,
    deleteRecord,
  });

  return {
    "Employee Contact List": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phoneNumber",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "note",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
  };
};
